import {useContext} from 'react'
import WebsiteIdContext from '@providers/WebsiteIdContext'

export default function useWebsiteId(): string {
  const websiteId = useContext(WebsiteIdContext)

  return websiteId
}
